const PriceMeter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M12.8 3.2 3.2 12.8"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      opacity=".55"
    />
    <path
      d="M6.6 3.1c0 1.1-.8 1.9-1.8 1.9S3 4.2 3 3.1s.8-1.9 1.8-1.9 1.8.8 1.8 1.9ZM13 12.9c0 1.1-.8 1.9-1.8 1.9s-1.8-.8-1.8-1.9.8-1.9 1.8-1.9 1.8.8 1.8 1.9Z"
      stroke="currentColor"
      strokeWidth="1.3"
    />
  </svg>
)

export { PriceMeter }
